import axios from '@/utils/request';
const v1 = 'v1/admin/transaction';
const v2 = 'v2/admin/transaction';

export const v2GetSales = ({ company_id = 1, client_id, mvm_id, date, payment_code }, { size = 10, page = 1 }, sale_ordering = null, timeout = 200000) =>
  axios.get(`${v2}/sales`, {
    params: { company_id, client_id, mvm_id, date, page, size, payment_code, prop: sale_ordering.prop, order: sale_ordering.order },
    timeout,
  });

export const v2GetSalesCsv = ({ company_id = 1, client_id, mvm_id, date, payment_code }, { size = 10, page = 1 }, sale_ordering = null, timeout = 600000, filename = `sales.csv`) =>
  axios.post(
    `${v2}/sales-csv`,
    { filename },
    {
      params: { company_id, client_id, mvm_id, date, page, size, payment_code, prop: sale_ordering.prop, order: sale_ordering.order },
      timeout,
    },
  );

export const v2GetSum = ({ company_id = 1, show_all_mvm = true, client_id, mvm_id, date }, { size = 10, page = 1 }) =>
  axios.get(`${v2}/sum`, {
    params: { company_id, client_id, mvm_id, date, page, size, show_all_mvm },
  });

export const getSales = ({ company_id = 1, client_id, mvm_id, date }, { size = 10, page = 1 }, sale_ordering = null) =>
  axios.get(`${v1}/sales`, {
    params: { company_id, client_id, mvm_id, date, page, size, prop: sale_ordering.prop, order: sale_ordering.order },
  });

export const getSum = ({ company_id = 1, client_id, mvm_id, date }, { size = 10, page = 1 }) =>
  axios.get(`${v1}/sum`, {
    params: { company_id, client_id, mvm_id, date, page, size },
  });

export const getLastSales = () => axios.get(`${v1}/lastSales`);
export const getSalesByType = () => axios.get(`${v1}/salesByType`);

export const searchSales = (data, page) => axios.post(`${v1}/searchSales?page=${page}`, data);

export const searchMvmSales = (data, page) => axios.post(`${v1}/searchMvmSales?page=${page}`, data);
export const getTodaySales = () => axios.get(`${v1}/todaySales`);
export const getTodaySalesByType = () => axios.get(`${v1}/todaySalesByType`);
export const getYdSalesByType = () => axios.get(`${v1}/ydSalesByType`);
export const getMSalesByType = () => axios.get(`${v1}/MSalesByType`);
export const getLMSalesByType = () => axios.get(`${v1}/LMSalesByType`);

export const axiosApi = axios;

export const getTransactions = () => axios.get(`${v1}/index`);
export const searchTransactions = (dateRange) => axios.get(`v1/admin/transactions/search`, dateRange);
